import { track } from './core';

export function trackAppSettingsOpened(appId, appName) {
  track('app_settings_opened', { app_id: appId, app_name: appName });
}

export function trackAppSettingsSectionViewed(appId, appName, section) {
  track('app_settings_section_viewed', { app_id: appId, app_name: appName, section });
}

export function trackAppSettingsSaveClicked(appId, appName) {
  track('app_settings_save_clicked', { app_id: appId, app_name: appName });
}

export function trackAppSettingsInviteMemberClicked(appId, appName) {
  track('app_settings_invite_member_clicked', { app_id: appId, app_name: appName });
}

export function trackAppSettingsComplianceToggleChanged(appId, appName, toggleName, enabled) {
  track('app_settings_compliance_toggle_changed', { app_id: appId, app_name: appName, toggle_name: toggleName, enabled });
}

export function trackSettingsSaved() {
  track('settings_saved');
}

export function trackSettingsOpened() {
  track('settings_opened');
}

export function trackSettingsSectionViewed(section) {
  track('settings_section_viewed', { section });
}

export function trackSettingsLogoutClicked() {
  track('settings_logout_clicked');
}

export function trackSettingsSessionRevoked() {
  track('settings_session_revoked');
}

export function trackSettingsTokenGenerated() {
  track('settings_token_generated');
}
